module.exports = __webpack_public_path__ + "static/media/email.f71a07e2.png";